import React from "react";
import { useTranslation } from "react-i18next";
import { FiX, FiCheck, FiArrowLeft } from "react-icons/fi";
import styles from "./ModalConfirmNewPreset.module.scss";

const ModalConfirmNewPreset = ({
  setOverlay,
  success,
  setModalConfirmRegisterNewPreset,
  registerNewValue,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.modal}>
      <button
        type="button"
        className={styles.closeBtn}
        onClick={() => {
          setOverlay(false);
          setModalConfirmRegisterNewPreset(false);
        }}
      >
        <FiX />
      </button>
      <h3>{t("calibration_data.save_new_presets_question")}</h3>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.btnDanger}
          onClick={() => {
            setModalConfirmRegisterNewPreset(false);
            setOverlay(false);
          }}
        >
          <FiArrowLeft /> {t("calibration_data.revert_to_previous")}
        </button>
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={registerNewValue}
        >
          <FiCheck /> {t("calibration_data.save_preset")}
        </button>
      </div>
    </div>
  );
};

export default ModalConfirmNewPreset;
